import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import { IProviderFiltersProps } from './ProviderFilters';
import { makeSearchParams, parseSearchParams } from '../../utils/utilities';

interface Props {
	providerId: string;
	children: JSX.Element | string | number;
}

export const ProviderLayout: FC<Props> = (props) => {
	const { providerId, children } = props;
	const navigate = useNavigate();
	const { pathname, search } = useLocation();

	const filtersFromUrl: IProviderFiltersProps = parseSearchParams(search) || {};

	const params: IProviderFiltersProps = { ...filtersFromUrl };
	params.providerId = providerId;

	if (!params.isActive) {
		params.isActive = 'true';
	}

	return (
		<div
			className="cursor-pointer"
			onClick={(): void => navigate(`${pathname}?${makeSearchParams(params)}`)}
		>
			{children}
		</div>
	);
};
